module.exports = __webpack_public_path__ + "images/vehicle-project.1dc40ece8401c4e90a93026098d119f4.png";